<template>
  <OwnCard
    v-if="!!clickHandler"
    el="button"
    :class="['own-callout w-full', `own-callout--${type}`]"
    control
    :hide-border="true"
    @click="clickHandler"
  >
    <OwnCalloutContent :body="body" :title="title" :type="type" :icon="icon">
      <template #body>
        <slot name="body" />
      </template>
    </OwnCalloutContent>
  </OwnCard>
  <OwnCard
    v-else
    :class="['own-callout', `own-callout--${type}`]"
    :hide-border="true"
  >
    <OwnCalloutContent :body="body" :title="title" :type="type" :icon="icon">
      <template #body>
        <slot name="body" />
      </template>
    </OwnCalloutContent>
  </OwnCard>
</template>

<script lang="ts">
/**
 * @deprecated - use OwnCalloutV2 instead
 */
export default {}
</script>

<script lang="ts" setup>
import { Component } from 'vue'

import { OwnCard } from '../OwnCard'

import OwnCalloutContent from './OwnCalloutContent.vue'

withDefaults(
  defineProps<{
    body?: string
    title?: string
    type?: 'warning' | 'danger' | 'brand' | 'neutral' | 'success'
    icon?: Component
    clickHandler?: () => Promise<void> | undefined
  }>(),
  {
    body: undefined,
    clickHandler: undefined,
    el: 'div',
    icon: undefined,
    title: undefined,
    type: 'neutral',
  }
)
</script>

<style lang="scss">
@mixin define-color($color) {
  background:
    linear-gradient(0deg, rgba($color, 0.05) 0%, rgba($color, 0.05) 100%), #fff;
  color: rgb($color);
}

.own-callout {
  padding: 16px;
  &--danger {
    @include define-color(var(--raw-status-danger));
  }

  &--success {
    @include define-color(var(--raw-status-success));
  }

  &--warning {
    @include define-color(var(--raw-status-warning));
  }

  &--brand {
    @include define-color(var(--raw-misc-brand));
  }

  &--neutral {
    @include define-color(var(--raw-text-color-tertiary));
  }
}
</style>
